import { IconProps } from './IconProps';
export function PencilIcon(props: IconProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_6111_95341)">
                <path
                    d="M22.19 1.81035C21.8494 1.47116 21.4449 1.20282 20.9999 1.02084C20.555 0.838852 20.0784 0.746829 19.5977 0.750083C19.117 0.753338 18.6417 0.851804 18.1993 1.0398C17.7568 1.22779 17.356 1.50158 17.02 1.84535L2.52 16.3453L0.75 23.2504L7.655 21.4794L22.155 6.97935C22.4989 6.64348 22.7727 6.24279 22.9608 5.80043C23.1488 5.35806 23.2473 4.88281 23.2506 4.40215C23.2539 3.92149 23.1618 3.44495 22.9798 3.00008C22.7977 2.55521 22.5293 2.15084 22.19 1.81035Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.6094 2.25977L21.7434 7.39377"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.52344 16.3438L7.66244 21.4738"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_6111_95341">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
